import { c as _c } from "react/compiler-runtime";
import type { CommonProductCard, CtaAnalyticsProps, SegmentActionNamePrefixType } from '../../model/types';
import { CardDetails } from './CardDetails';
import { NerdwalletsTake } from './NerdwalletsTake';
import { RewardsBreakdown } from './RewardsBreakdown';
export const Accordions = t0 => {
  const $ = _c(27);
  const {
    creditCardOffer,
    initiallyExpanded,
    analytics,
    segmentActionNamePrefix,
    actionSection
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    rewardsRates
  } = t1;
  const initiallyExpandedSection = rewardsRates.length === 0 ? "cardDetails" : "rewardsBreakdown";
  const t2 = `product-content-${creditCardOffer.id}`;
  let t3;
  if ($[0] !== initiallyExpanded || $[1] !== initiallyExpandedSection) {
    t3 = initiallyExpanded && {
      expandedByDefault: initiallyExpandedSection === "rewardsBreakdown"
    };
    $[0] = initiallyExpanded;
    $[1] = initiallyExpandedSection;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== actionSection || $[4] !== creditCardOffer || $[5] !== segmentActionNamePrefix || $[6] !== t3) {
    t4 = <RewardsBreakdown actionSection={actionSection} creditCardOffer={creditCardOffer} segmentActionNamePrefix={segmentActionNamePrefix} {...t3} />;
    $[3] = actionSection;
    $[4] = creditCardOffer;
    $[5] = segmentActionNamePrefix;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== initiallyExpanded || $[9] !== initiallyExpandedSection) {
    t5 = initiallyExpanded && {
      expandedByDefault: initiallyExpandedSection === "cardDetails"
    };
    $[8] = initiallyExpanded;
    $[9] = initiallyExpandedSection;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== actionSection || $[12] !== analytics || $[13] !== creditCardOffer || $[14] !== segmentActionNamePrefix || $[15] !== t5) {
    t6 = <CardDetails actionSection={actionSection} analytics={analytics} creditCardOffer={creditCardOffer} segmentActionNamePrefix={segmentActionNamePrefix} {...t5} />;
    $[11] = actionSection;
    $[12] = analytics;
    $[13] = creditCardOffer;
    $[14] = segmentActionNamePrefix;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== actionSection || $[18] !== analytics || $[19] !== creditCardOffer || $[20] !== segmentActionNamePrefix) {
    t7 = <NerdwalletsTake actionSection={actionSection} analytics={analytics} creditCardOffer={creditCardOffer} segmentActionNamePrefix={segmentActionNamePrefix} />;
    $[17] = actionSection;
    $[18] = analytics;
    $[19] = creditCardOffer;
    $[20] = segmentActionNamePrefix;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t2 || $[23] !== t4 || $[24] !== t6 || $[25] !== t7) {
    t8 = <div id={t2}>{t4}{t6}{t7}</div>;
    $[22] = t2;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};